import { css } from 'lit';

export const backBtnStyle = css`
  .back-btn {
    position: absolute;
    top: 20px;
    left: 20px;
    color: black;
    border: var(--border-default);
    border-radius: 50%;
    height: 40px;
    width: 40px;
    cursor: pointer;
    text-decoration: none;
    font-size: 1rem;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const sharedStyles = css`
  .text-headline {
    font-family: var(--font-headline);
    font-size: var(--font-size-headline);
  }

  .text-headline--black {
    color: black;
  }

  .text-headline--white {
    color: white;
  }

  .text-title {
    font-family: var(--font-title);
    font-weight: 800;
  }

  .text-title--black {
    color: black;
  }

  .text-title--white {
    color: white;
  }

  .text-body {
    font-family: var(--font-text);
    font-size: var(--font-size-text);
    line-height: var(--line-height-text);
  }

  .text-body--small {
	font-family: var(--font-text);
	font-size: 14px;
  }

  .text-body--black {
    color: black;
  }

  .text-body--white {
    color: white;
  }

  p {
    font-family: var(--font-text);
    font-size: var(--font-size-text);
    color: black;
    line-height: var(--line-height-text);
    margin: 0 0;
  }

  h1 {
    font-family: var(--font-headline);
    font-size: 2rem;
    color: black;
    margin: 0 0;
  }

  h2 {
    font-family: var(--font-headline);
    font-size: 1.5rem;
    color: black;
    margin: 0 0;
  }

  label {
    font-family: var(--font-text);
    font-size: 1rem;
    color: black;
  }
`;
